/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

/**
 * Determines if a given src URL is a hygraph asset
 * @param hygraphMediaDomain
 * @param src
 * @returns boolean
 */
export const isHygraphImageSrc = (hygraphMediaDomain: string, src: string): boolean => {
	const isHygraph = Boolean(src.includes(hygraphMediaDomain) || src.includes(".graphassets.com"));
	return isHygraph;
};

interface HygraphImageIds {
	assetId: string;
	environmentId?: string;
}

/**
 * Attempts to parse hygraph asset URL and return the assetId, environmentId
 */
export const getHygraphImageIds = (hygraphMediaDomain: string, src: string): HygraphImageIds => {
	let assetId = "";
	let environmentId = "";

	if (!src) {
		return { assetId, environmentId };
	}

	const parts = src.split("/");

	if (parts.length && parts[2] && isHygraphImageSrc(hygraphMediaDomain, parts[2]) && parts.length > 3) {
		assetId = parts[3];

		//new system
		if (parts.length >= 5) {
			// remove output= resize=x: parts
			const cleanedIds = parts.slice(4).filter((el) => el && !el.includes(":") && !el.includes("="));
			if (cleanedIds.length > 0) environmentId = cleanedIds[0];
		}
	}

	return { assetId, environmentId };
};
